import { render, staticRenderFns } from "./MetadataTab.vue?vue&type=template&id=0af18672&scoped=true"
import script from "./MetadataTab.component.js?vue&type=script&lang=js&external"
export * from "./MetadataTab.component.js?vue&type=script&lang=js&external"
import style0 from "./MetadataTab.vue?vue&type=style&index=0&id=0af18672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af18672",
  null
  
)

export default component.exports